import React from 'react';
import './style.scss';


export default props => (
  <div className="tour-screen" />
)
